import { LoadingScene } from "./scenes/LoadingScene";
import Phaser from "phaser";
import { AlpineScene } from "./scenes/AlpineScene";

export function createGame(parent: string, seed: string): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.CANVAS,
    audio: {
      noAudio: true,
    },
    parent,
    loader: { timeout: 20_000, maxRetries: 1 },
    backgroundColor: "#dbe9e9",
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: "100%",
      height: "100%",
    },
    render: {
      antialias: true,
      desynchronized: true,
      roundPixels: false,
    },
    banner: false,
    scene: [new LoadingScene(), new AlpineScene(seed)],
  });
}
